const main = {
  'App support link':
    'https://support.shoplineapp.com/hc/zh-cn/articles/23966890906649',
  'Config GMC': 'Google Merchant Center - 购物广告设定',
  'Config GMC Caption':
    '透过 Content API 串接能自动上载你的商品资料到 Google Merchant Center，可以在 Google 广告及其他 Google 服务中使用。请连结 Google Merchant Center 的子帐户。',
  'Merchant Center ID': 'Google Merchant ID',
  'Merchant Center ID - description_unintegrated':
    '你的网店尚未与任何 Google Merchant Center 帐户串接并完成验证，请前往 基本资料 > 第三方网域工具 > Google Merchant Center 串连',
  'Merchant Center ID - description_integrated':
    '启用 Content API 后，将会传送产品资料至以下验证完成的 Google Merchant Center 帐户。',
  'Merchant Center ID - action button_unintegrated': '前往串接',
  'Merchant Center ID - action button_integrated': '查看设定',
  'Preorder Period': '出货递延天数',
  'Merchant has been saved successfully': '商家设定已成功保存',
  'Failed to save merchant': '商家设置保存失败',
  'Failed to connect with MCA merchant':
    '串接失败，请勿使用 MCA (multi-client account) 帐号进行串接',
  'Failed to connect with invalid domain':
    '串接失败，请确认你的 Google Merchant Center 帐号已完成网域验证',
  'Successfully set the Region and Language for Ads Delivery':
    '成功设定广告投放地区及语系',
  'Please enter numbers only': '请输入有效的 GMC ID',
  'The shipping delay days cannot be left blank or set to fewer than 30.':
    '出货递延天数不可留空或小于 30',
  'Upload products to GMC': '上传商品至 GMC 功能',
  'Upload products to GMC - description':
    '请务必将以下连结复制并加入 Google Merchant Center，方能成功使用 Content API 即时上传商品至 GMC 功能',
  'Upload products to GMC - step 1': '1. 点击右边 icon 复制 Email',
  'Upload products to GMC - step 2':
    '2. 进入 Google Merchant Center > 工具与设定（右上角偏中间齿轮 icon 点入） > 帐户存取权 > 使用者',
  'Upload products to GMC - step 3': '3. 新增使用者并 Share 管理员权限至使用者',
  'Save before leaving': '请注意，在离开此页之前，请先储存内容。',
  'Authorize Content API Title': '授权 Content API 服务帐户使用权限',
  'Authorize Content API Description':
    '请依照 <1>FAQ</1> 指示，前往 Google Merchant Center 后台下载 Content API 服务帐号凭证，并将凭证档案上传于此',
  'Content API FAQ Link':
    'https://support.shoplineapp.com/hc/zh-tw/articles/23966890906649',
  'Upload Files Here': '上传档案',
  'Invalid Credential File': '档案无效，请检查或更新你的凭证档案',

  'Config region & locale': '投放地区及语系设定',
  'Config region & locale Caption':
    '连接 Google Merchant Center 后，可以在此管理及无时无刻自动更新产品动态馈给。Google Merchant Center 会根据你设定的投放地区及语系将你的商品广告展示出去。',
  'Config region & locale Alert':
    '请注意，商品需填写符合投放语系的标题、摘要及描述才能成功上传。',
  'Signed in with Google': '已登入 Google 授权',
  "You're signed in with Google": '成功登入 Google 授权',
  'Automatically connect Merchant API — no manual setup required':
    '自动串接 Merchant API，无需手动设定',
  'Go to Google Merchant Center': '前往 Google Merchant Center 后台',
  'Sign in with your Google account': '请登入 Google 授权',
  'Sign in with Google': '登入 Google 授权',
  'Learn more': '了解更多',
  'Connect a new Google Merchant Center account?':
    '绑定新建立的 Google Merchant Center 账号？',
  'When your store is connected to a Google Merchant Center account, disconnecting it will have the following effects:':
    '当商店已串接 Google Merchant Center 账号时，解除串接将产生以下影响：',
  'Website ownership will be transferred to the new GMC account.':
    '网站所有权将转移至新的 GMC 账号',
  'Product data will be synced to the new GMC account.':
    '商品资料将同步至新的 GMC 账号',
  'Products in the original GMC account will be marked as "Disapproved".':
    '原 GMC 账号中的商品将被标示为「未核准」',
  'Ad campaigns linked to the original GMC account will be interrupted.':
    '原 GMC 账号所关联的广告投放将会中断',
  'The original GMC account will be deactivated and can no longer be used.':
    '原 GMC 账号将被关闭，无法再使用',
  'A GMC sub-account has been created in your SHOPLINE MCA':
    '您在 SHOPLINE MCA 的 GMC 子帐号已建立',
  'Create and connect Google Merchant Center account':
    '建立与串接 Google Merchant Center 帐号',
  'We will help you create a new GMC account using your authorized Google account and automatically connect it to SHOPLINE.':
    '我们会协助您使用授权的 Google 帐号建立 Google Merchant Center 帐号，并自动完成与 SHOPLINE 的串接。',
  'Connect now': '一键串接',
  'A new Merchant Center account has been created and connected to your store. Please check your inbox and accept the Google Merchant Center admin invitation.':
    '已为您建立新的 Merchant Center 账号并完成串接，请前往您的邮箱查收邮件，并接受 Google Merchant Center 管理邀请。',
  'Website ownership has been transferred to this account.':
    '网站所有权已转移至此账号',
  'Product data will be synced to this account.': '商品资料将同步至此账号',
  'Connected Merchant Center ID': '已串接 Merchant Center ID',
  Disconnect: '解除串接',
  'Disconnect Google Merchant Center account?':
    '解除 Google Merchant Center 帐号？',
  'Confirm Disconnect': '确认解除',
  'Product data will stop syncing, and any ads linked to this account will be paused. Are you sure you want to disconnect from Google Merchant Center?':
    '商品资料将停止同步，且与此帐号连结的广告投放将会中断。请确认是否要解除与 Google Merchant Center 的串接？',
  'Let Google Merchant Center determine the shipping date for pre-order products.':
    '让 Google Merchant Center 判断预购商品的出货日期',
  'Connect Merchant API': 'Merchant API 串接设定',
  'Through a Merchant API connection, your product data will be automatically uploaded to Google Merchant Center, allowing them to be accessible in Google Ads, YouTube Live Shopping, and other Google features.':
    '透过串接 Merchant API ，商品资料能够即时自动更新至 Google Merchant Center，并能应用于 Google 广告、YouTube Live Shopping 购物功能及其他 Google 服务。',
  'Connect Merchant API Label': '串接 Merchant API',
  Recommended: '最佳选择',
  'Recommended for real-time product sync, hidden product setting, and simplified maintenance.':
    '建议使用： 支援商品资料即时同步与隐藏商品设定，简化维护流程',
  'Do not connect Merchant API': '不串接 Merchant API',
  'Product data will not sync automatically. You must manually update the Product Feed in Google Merchant Center. This may affect product approval and exposure.':
    '商品资料无法即时同步，需自行前往 Google Merchant Center 更新 Product Feed，可能影响商品上架状态与曝光',
  'Saved successfully': '储存成功',
  'Setup incomplete': '设定尚未完成',
  'Placement area and placement language are not configured':
    '尚未设定投放地区及语系',
  'Merchant API settings not saved': '尚未储存 Merchant API 设定',
  'The system will temporarily save your settings as "Not connected to Merchant API".':
    '系统将自动为您暂时储存为不串接 Merchant API',
  'Apps Store': '扩充功能商店',
  'My Apps': '我的扩充功能',
  'If you need to manage the Google Merchant Center account, please contact the account owner and request manual authorization in the Google Merchant Center dashboard.':
    '若您需要管理 Google Merchant Center 帐号，请联系建立该帐号的管理员，并于 Google Merchant Center 后台手动授权您的帐号',
  'Are you sure you want to cancel?': '确认取消变更',
  'Any unsaved changes will be lost.': '编辑内容将不会保留，是否确认取消变更',
  'Continue editing': '继续编辑',
  'Cancel changes': '取消变更',
  "Your edits aren't saved": '尚未儲存變更',
  'If you leave, any unsaved changes will be lost. Please save before leaving.':
    '如果选择离开，编辑内容将不会保留，建议储存后再离开。',
  Leave: '离开',
  'Once you sign in, the Merchant API will be automatically connected to SHOPLINE with no manual setup needed. Your product data will be automatically uploaded to Google Merchant Center, allowing them to be accessible in Google Ads, YouTube Live Shopping, and other Google features.':
    '登入后，Merchant API 即可自动串接至 SHOPLINE，无需手动设定。商品资料将即时更新至 Google Merchant Center，并可用于 Google 广告、YouTube Live Shopping 及其他 Google 服务。',
  'Once you sign in, We will help you create and connect the Merchant Center account.':
    '登入后，我们将自动为您建立并串接 Merchant Center 账号。',
  'Your store is currently connected to Google Merchant Center (GMC). Signing in will disconnect the existing GMC account and automatically create and connect a new one.':
    '商店当前已有串接的 Google Merchant Center (GMC)，登入后，将解除绑定现有的 GMC 账号，并自动建立及串接新的 GMC 账号。',
  'Ad Placement Area and Language': '广告投放地区及语系',
  'The system will upload your products (including preorder and hidden products) to Google Merchant Center. Product ads will be displayed based on the selected placement area and language.':
    '系统将您的商品（包含预购、隐藏商品）上传至 Google Merchant Center 后，会根据您设定的投放地区及语系展示商品广告。',
  'Please enter the product name, summary, and description for the selected placement language to ensure successful product uploads.':
    '请注意，商品需填写符合投放语系的标题、摘要及描述方可成功上传。',
  Region: '投放地区',
  Locale: '投放语系',
  'Add a language to the list below': '新增语系至下方列表',
  'EmptyLocale - title': '还没有数据',
  'EmptyLocale - subtitle': '从上面的设置中添加语言',
  'Please contact the Online Merchant Success Team to enable this feature for your store.':
    '请联系线上顾问，为您的商店开启此功能权限',
  'To reconnect to Google Merchant Center, a new GMC account will be created following the new process to comply with Google\'s latest API standards. Please contact the Online Merchant Success Team to enable the "Automatically create and connect Merchant API" feature.':
    '若需重新串接 Google Merchant Center，将依新流程建立全新的 GMC 账号，以符合 Google 最新 API 规范。请联系线上顾问启用「自动建立与串接 Merchant API」功能。',
  'Sign in and authorize now to upgrade from Content API to Merchant API':
    '立即登入授权，将 Content API 升级为 Merchant API',
  'Due to Google policy changes, the Content API will be deprecated on 18 August 2026, and replaced by the Merchant API.':
    '因应 Google 政策，Content API 将于 2026/08/18 下架，由 Merchant API 取代。',
  'Please complete the API upgrade as soon as possible to prevent any disruption to product uploads and ad delivery.':
    '请尽快完成 API 升级，以免影响商品上传与广告投放。',
  'Once authorized, you can upgrade to the Merchant API instantly with no manual setup required.':
    '登入授权后即可一键升级至 Merchant API，无需手动设置。',
  "We recommend that the store owner perform the authorization to avoid disruptions caused by changes to a staff member's account status or permissions.":
    '建议由店长进行授权，避免授权人员的 GMC 账号停用或权限变更，影响商品上传及广告投放。',
  "If the authorized staff member's GMC account is suspended or permissions change, product uploads and ad delivery will be affected. If any changes occur, please contact the Online Merchant Success Team.":
    '若授权人员的 GMC 账号停用或权限变更，将影响商品上传及广告投放。如有任何异动，请联系线上顾问。',
  'Google discontinued the Content API on 18 August 2026. Please upgrade to the Merchant API to keep syncing product data with your GMC account.':
    'Google 已于 2026/08/18 停止 Content API 服务，如需持续更新商品资料到 GMC 账号，请升级到 Merchant API。',
  'Successfully upgraded to Merchant API': '成功升级为 Merchant API',
  'Content API has been upgraded to Merchant API. Your previous settings have been automatically applied. No reconfiguration is needed.':
    'Content API 已升级为 Merchant API，原有设置已为您自动沿用，无需重新设置。',
  'Upgrade Content API to Merchant API': '将 Content API 升级为 Merchant API',
  'If you need to disconnect Google Merchant Center, please contact the Online Merchant Success Team for assistance.':
    '若需解除串接 Google Merchant Center，请联系线上顾问。',
  'Disconnect Google Merchant Center?': '解除串接 Google Merchant Center？',
  'Product data syncing will stop, and ads linked to this account will be interrupted.':
    '商品资料将停止同步，与此账号关联的广告投放将中断。',
  'Your current Google account does not have administrative access to this GMC account. Please contact the store owner for authorization.':
    '您目前使用的 Google 账户没有该 GMC 的管理权限，请联系店长进行授权。',
  'Insufficient permissions. Please log in to Google again and grant the required access.':
    '权限不足，请重新登录 Google 并完成相关授权',
  DATA_TABLE: {
    REGION: '地区',
    LOCALE: '语系',
    ACTION: '开启/关闭',
  },
  LOCALE: {
    'zh-hant': '中文 - 台湾',
    'zh-tw': '中文 - 台湾',
    'zh-hk': '中文 - 香港特别行政区',
    'zh-cn': '中文 - 中国',
    en: '英语',
    ms: '马来语',
    th: '泰语',
    vi: '越南语',
    id: '印尼语',
    de: '德语',
    fr: '法语',
    ja: '日语',
  },
  REGION: {
    TW: '台湾',
    CN: '中国',
    HK: '香港',
    JP: '日本',
    SG: '新加坡',
    MY: '马来西亚',
    TH: '泰国',
    VN: '越南',
    PH: '菲律宾',
    US: '美国',
    AU: '澳大利亚',
    GB: '英国',
  },
  UNIT: {
    days: '天',
  },
};

export default main;
